// Copyright 2026 The Simlin Authors. All rights reserved.
// Use of this source code is governed by the Apache License,
// Version 2.0, that can be found in the LICENSE file.

// D7.2: the account-tier badge shown in the app shell. A quiet pill so a user
// always knows which plan gates the surfaces around them. Pure presentation over
// the shared Tier ladder (@simlin/core); the gating itself lives in tier-policy.

import * as React from 'react';

import { Tier } from '@simlin/core/tier';

import { tierLabel } from './tier-label';

import styles from './TierBadge.module.css';

// Map each tier to a class so the pill can carry a subtle, escalating accent
// without hard-coding colors here (theme.css owns the values).
const TIER_CLASS: Record<Tier, string> = {
  [Tier.Public]: styles.free,
  [Tier.Student]: styles.student,
  [Tier.Member]: styles.member,
  [Tier.Advanced]: styles.advanced,
};

interface TierBadgeProps {
  tier: Tier;
  className?: string;
}

export const TierBadge: React.FC<TierBadgeProps> = ({ tier, className }) => {
  const label = tierLabel(tier);
  return (
    <span
      className={[styles.badge, TIER_CLASS[tier] ?? styles.free, className].filter(Boolean).join(' ')}
      title={`Your plan: ${label}`}
      aria-label={`Plan: ${label}`}
    >
      {label}
    </span>
  );
};
